import { Box, Button, Heading, Stack } from '@chakra-ui/react'
import MasonryGrid, {
  renderCardComponent,
} from '@src/components/sco/InvestorOutreachLP/components/blocks/MasonryGrid'
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { processCardsData } from '@src/components/sco/utilities/cardUtils'
import React from 'react'

export const MasonryGridBlock = (props: any) => {
  const { getBreakpointValue } = useBreakpointContext()

  // Masonry Grid data

  const idsToRenderForMasonryGrid = [
    'sc4',
    'ohc1',
    'bc17',
    'sc6',
    'qc3',
    'bc19',
    // 'pc1',
    'sc9',
    'pc2',
    'bc5',
    'sc1',
    'qc6',
    'bc8',
    'bc7',
    'bc2',
    'bc3',
    'bc4',
  ]
  const sortedCardsForMasonryGrid = processCardsData(idsToRenderForMasonryGrid)
  const masonryGridCardComponents = sortedCardsForMasonryGrid.map((data, index) =>
    renderCardComponent(data, index)
  )

  return (
    <SectionWrapper
      bgColor={props.background || 'colorPalette.panel'}
      overflow={'hidden'}
      paddingTop={getBreakpointValue([6, 6, 8, 10, 16])}
      paddingY={0}
      removeBottomPadding={true}
    >
      <Heading
        color={'purpleLightAlpha.600'}
        size={getBreakpointValue(['2xl', '4xl', '5xl'])}
        textAlign={'center'}
      >
        {'Join Over'}{' '}
        <Box as={'span'} color={'orange.fg'}>
          1 Million Startups
        </Box>{' '}
        on our Platform
      </Heading>
      <MasonryGrid cards={masonryGridCardComponents} />
      <Stack
        align={'center'}
        direction={{ base: 'column', md: 'column' }}
        gap={8}
        justify={'space-between'}
        marginBottom={10}
        overflow={'visible'}
        padding={getBreakpointValue([5, 6, 10])}
        position={'relative'}
        width={'full'}
      >
        <Box
          aspectRatio={1}
          bgImage={'radial-gradient(circle, {colors.purple.solid/40}, transparent 70%)'}
          left={'50%'}
          pointerEvents={'none'}
          position={'absolute'}
          top={'50%'}
          transform={'translate(-50%, -50%)'}
          w={{ base: '320px', md: '1220px' }}
          zIndex={0}
        />
        <Heading position={'relative'} size={'5xl'} textAlign={'center'} zIndex={1}>
          {'This is their story.'}{' '}
          <Box as={'span'} color={'orange.fg'}>
            Let's make it yours.
          </Box>
        </Heading>
        <Button asChild position={'relative'} size={'xl'} variant={'cta'} zIndex={1}>
          <a href={'/success'}>Read more success stories</a>
        </Button>
      </Stack>
    </SectionWrapper>
  )
}
